import React from 'react';
import { Typography, TypographyProps } from '@material-ui/core';

interface Props extends TypographyProps {
  children: React.ReactNode;
  component?: React.ElementType;
}

const BreakableTypography: React.FC<Props> = ({ children, ...props }) => {
  return (
    <Typography style={{ overflowWrap: 'anywhere' }} {...props}>
      {children}
    </Typography>
  );
};

export default BreakableTypography;
